import { useIncidenceFilterContext } from 'modules/bookkeepers/lib/IncidenceFilterContext'
import { usePayrollExportsContext } from 'modules/bookkeepers/pages/Clients/PayrollExports'
import {
  PolicyPeriodsProvider,
  usePolicyPeriods,
} from 'modules/payroll_bundle/lib/policyPeriodsContext'
import { PolicyPeriods } from 'modules/payroll_bundle/store/collections/policyPeriods'
import PayrollExportModal from 'modules/payroll_exporter/components/PayrollExportModal'

const PayrollExportModalWithPolicyPeriod = () => {
  const policyPeriodCollection = new PolicyPeriods()

  /**
   * TODO: Need to investigate why selectedCompany is undefined coming from outlet context
   * const { selectedCompany, onClose } = usePayrollExportsContext()
   */
  const { onClose } = usePayrollExportsContext()
  const { selectedCompany: filterContextCompany } = useIncidenceFilterContext()
  const selectedCompanyId = filterContextCompany?.attributes.id
  const policyPeriodsContext = usePolicyPeriods()

  const content = (
    <PayrollExportModal onClose={onClose} selectedCompany={selectedCompanyId} isProfessionals />
  )

  // If the component is rendered without a PolicyPeriodsProvider, create one
  return policyPeriodsContext.policyPeriodCollection ? (
    content
  ) : (
    <PolicyPeriodsProvider policyPeriodCollection={policyPeriodCollection} isBookkeeper>
      {content}
    </PolicyPeriodsProvider>
  )
}

export default PayrollExportModalWithPolicyPeriod
